<template>
    <div class="register-container">
        <div class="register-box">
            <div class="title">用户注册</div>
            <el-form ref="registerForm" :model="registerForm" :rules="rules" @submit.native.prevent="handleRegister"
                class="register-form">
                <!-- 邀请码输入 -->
                <el-form-item label="邀请码" prop="inviteCode">
                    <el-input v-model="registerForm.inviteCode" placeholder="请输入邀请码" clearable
                        @blur="validateInviteCode" />
                </el-form-item>


                <!-- 推广名称 -->
                <el-form-item label="昵称" prop="positionName">
                    <el-input v-model="registerForm.positionName" placeholder="请输入推广昵称" clearable />
                </el-form-item>

                <!-- 推广密码 -->
                <el-form-item label="密码" prop="positionPsd">
                    <el-input v-model="registerForm.positionPsd" type="password" placeholder="请设置推广密码" clearable
                        show-password />
                </el-form-item>

                <!-- 确认密码 -->
                <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input v-model="registerForm.confirmPassword" type="password" placeholder="请再次输入密码" clearable
                        show-password />
                </el-form-item>

                <!-- 手机号 -->
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="registerForm.phone" placeholder="请输入手机号" clearable maxlength="11" />
                </el-form-item>

                <!-- 验证码 -->
                <el-form-item label="验证码" prop="smsCode">
                    <div style="display: flex; gap: 10px;">
                        <el-input v-model="registerForm.smsCode" placeholder="请输入验证码" clearable maxlength="4"
                            style="flex: 1;" />
                        <el-button :disabled="codeCountdown > 0 || sendingCode" @click="sendSmsCode"
                            :loading="sendingCode"
                            style="width: 100px;height: 30px;line-height: 6px;color: #42b983;border-color: #42b983;">
                            {{ codeCountdown > 0 ? `${codeCountdown}秒` : '获取验证码' }}
                        </el-button>
                    </div>
                </el-form-item>
                <!-- 提交按钮 -->

                <el-button type="primary" native-type="submit" :loading="registering" class="register-btn">
                    {{ registering ? '注册中...' : '注册' }}
                </el-button>

                <!-- 登录链接 -->
                <div class="login-link">
                    <span>已有账号？</span>
                    <el-button type="text" @click="goToLogin">立即登录</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { validateInviteCode, registerUser, login, sendRegisterCode } from '@/utils/jdApi'

export default {
    name: 'RegisterA',
    data() {
        return {
            registering: false,
            sendingCode: false,
            codeCountdown: 0,
            inviteCodeValid: false,
            registerForm: {
                inviteCode: '',
                phone: '',
                smsCode: '',
                positionName: '',
                positionPsd: '',
                confirmPassword: ''
            },
            rules: {
                inviteCode: [
                    { required: true, message: '请输入邀请码', trigger: 'blur' },
                ],
                positionName: [
                    { required: true, message: '请输入昵称', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    {
                        pattern: /^1[3-9]\d{9}$/,
                        message: '请输入正确的手机号',
                        trigger: 'blur'
                    }
                ],
                smsCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    {
                        pattern: /^\d{4}$/,
                        message: '验证码为4位数字',
                        trigger: 'blur'
                    }
                ],
                positionPsd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
                confirmPassword: [
                    { required: true, message: '请确认密码', trigger: 'blur' },
                    { validator: this.validateConfirmPasswordRule, trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        // 从URL参数获取邀请码
        const inviteCode = this.$route.query.invite
        if (inviteCode) {
            this.registerForm.inviteCode = inviteCode
            this.validateInviteCode()
        }
    },
    methods: {

        validateConfirmPasswordRule(rule, value, callback) {
            if (!value) {
                callback(new Error('请确认密码'))
                return
            }
            if (value !== this.registerForm.positionPsd) {
                callback(new Error('两次输入的密码不一致'))
                return
            }
            callback()
        },

        validateInviteCode() {
            if (!this.registerForm.inviteCode) {
                this.inviteCodeValid = false
                return
            }
            validateInviteCode(this.registerForm.inviteCode).then(response => {
                if (response.success && response.data) {
                    this.inviteCodeValid = true
                } else {
                    this.inviteCodeValid = false
                }
            }).catch(() => {
                this.inviteCodeValid = false
            })
        },

        sendSmsCode() {
            // 验证手机号
            if (!this.registerForm.phone) {
                this.$message.error('请先输入手机号')
                return
            }

            if (!/^1[3-9]\d{9}$/.test(this.registerForm.phone)) {
                this.$message.error('请输入正确的手机号')
                return
            }

            this.sendingCode = true
            sendRegisterCode(this.registerForm.phone).then(response => {
                if (response.success) {
                    this.$message.success(response.message || '验证码发送成功（5分钟内有效）')
                    // 开始倒计时
                    this.codeCountdown = 300
                    const timer = setInterval(() => {
                        this.codeCountdown--
                        if (this.codeCountdown <= 0) {
                            clearInterval(timer)
                        }
                    }, 1000)
                } else {
                    this.$message.error(response.message || '验证码发送失败')
                }
            }).catch(() => {
                this.$message.error('验证码发送失败，请稍后重试')
            }).finally(() => {
                this.sendingCode = false
            })
        },

        handleRegister() {
            this.$refs.registerForm.validate((valid) => {
                if (!valid) {
                    return
                }
                if (!this.inviteCodeValid) return this.$message.error('邀请码无效')
                this.registering = true
                registerUser(this.registerForm).then(response => {
                    if (response.success) {
                        this.$message.success('注册成功！已自动为您登录')
                        // 从响应中获取生成的positionId
                        const positionId = response.positionId || response.data?.positionId
                        if (!positionId) {
                            this.$message.error('注册成功但未获取到推广ID，请手动登录')
                            this.$router.push('/login')
                            return
                        }
                        const creds = { positionId: positionId, password: this.registerForm.positionPsd }
                        login(creds).then(async loginRes => {
                            if (loginRes && loginRes.success) {
                                localStorage.setItem('token', loginRes.token)
                                localStorage.setItem('user', JSON.stringify(loginRes.user))
                                const saved = {
                                    positionId: creds.positionId,
                                    password: creds.password,
                                    rememberPassword: true
                                }
                                localStorage.setItem('savedCredentials', JSON.stringify(saved))
                                this.$router.push('/promotion')
                            } else {
                                localStorage.removeItem('token')
                                localStorage.removeItem('user')
                                this.$router.push('/login')
                            }
                        }).catch(() => {
                            this.$message.error('登录失败，请手动登录')
                            localStorage.removeItem('token')
                            localStorage.removeItem('user')
                            this.$router.push('/login')
                        })
                    } else {
                        this.$message.error(response.message || '注册失败')
                    }
                }).finally(() => {
                    this.registering = false
                })
            })
        },

        goToLogin() {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.$router.push('/login')
        }
    }
}
</script>

<style scoped lang="scss">
.register-container {
    min-height: 100vh;
    /* background: #42b983; */
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    background: linear-gradient(#42b983 0%, rgba(66, 185, 131, 0.35) 70%, rgba(66, 185, 131, 0.35) 100%);
}

.register-box {
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    width: 100%;
    max-width: 500px;
}

.title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #42b983;
    margin-bottom: 30px;
}

.register-form {
    width: 100%;
}

.register-btn {
    width: 100%;
    height: 40px;
    font-size: 16px;
    background: #42b983;
    border-color: #42b983;
}

.register-btn:hover {
    background: #369870;
    border-color: #369870;
}

.login-link {
    text-align: center;
    color: #666;
    margin-top: 15px;
}

.login-link .el-button {
    color: #42b983;
    font-weight: 500;
}

.login-link .el-button:hover {
    color: #369870;
}

/* el-form 样式优化 */
.register-form .el-form-item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.register-form .el-form-item__label {
    font-weight: 500;
    color: #333;
}

::v-deep .el-form-item__content {
    flex: 1 !important;
}

/* 移动端适配 */
@media (max-width: 768px) {
    .register-container {
        padding: 20px;
    }

    .register-box {
        padding: 20px;
    }

    .title {
        font-size: 20px;
        margin-bottom: 20px;
    }
}

.el-button {
    padding: 0px !important;
}

.el-button:focus,
.el-button:hover {
    color: #42b983;
    border: 1px solid #42b983;
}
</style>
